<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9">

	<div class="col-md-4" *ngFor="let item of data">
		<div class="card card-flush h-md-100">
			<div class="card-header">
				<div class="card-title">
					<h2>{{item.name}}</h2>
				</div>
			</div>
			<div class="card-body pt-1">
				<div class="fw-bold text-gray-600 mb-5">Total users with this role: {{item.users_count}}</div>
				<div class="d-flex flex-column text-gray-600" *ngIf="item.is_admin">
					<div class='d-flex align-items-center py-2'>
						<span class='bullet bg-secondary me-3'></span>
						<em>All permissions assigned</em>
					</div>
				</div>
				<div class="d-flex flex-column text-gray-600" *ngIf="!item.is_admin">
					<div class="d-flex align-items-center py-2" *ngFor="let permission of getPermissionDescription(item.permissions)">
						<span class="bullet bg-primary me-3"></span>{{permission}}
					</div>
					<div class='d-flex align-items-center py-2' *ngIf="getPermissionDescription(item.permissions).length === 0">
						<span class='bullet bg-secondary me-3'></span>
						<em>No permissions assigned</em>
					</div>
				</div>
			</div>
			<div class="card-footer flex-wrap pt-0">
				<a [routerLink]="['/common','admin-users','roles', item._id]" class="btn btn-sm btn-primary my-1 me-2">Role Detail</a>
				<button type="button" class="btn btn-sm btn-dark my-1" (click)="editRole(item)">Edit Role</button>
			</div>
		</div>
	</div>

	<div class="col-md-4">
		<div class="card h-md-100">
			<div class="card-body d-flex flex-center">
				<button type="button" class="btn btn-clear d-flex flex-column flex-center" data-bs-toggle="modal" data-bs-target="#kt_modal_add_role">
					<img src="assets/media/illustrations/sketchy-1/4.png" alt="" class="mw-100 mh-150px mb-7" />
					<div class="fw-bold fs-3 text-gray-600 text-hover-primary">Add New Role</div>
				</button>
			</div>
		</div>
	</div>

</div>